<template>
  <div class="calculate-tips">
    <div v-if="title || price" class="title-wrap">
      <span>{{ title }}</span>
      <span>{{ price }}</span>
    </div>
    <div class="desc">
      <p>{{ desc }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoveTips',
  props: ['title', 'price', 'desc'],
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.calculate-tips {
  width: 100%;
  .title-wrap {
    .font-regular;
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: @app-black-color;
    font-weight: 500;
    font-size: 14px;
  }
  .desc {
    .font-regular;
    font-size: 12px;
    overflow: hidden;
    color: @app-body-color;
    white-space: normal;
  }
}
</style>
